import { cn } from '@/lib/utils';

interface TypingIndicatorProps {
  className?: string;
}

export const TypingIndicator = ({ className }: TypingIndicatorProps) => {
  return (
    <div className={cn('flex w-7 items-center justify-between text-muted-foreground', className)}>
      <div className="w-1/4 animate-elevator overflow-hidden rounded-full bg-current pb-[25%] delay-200" />
      <div className="w-1/4 animate-elevator overflow-hidden rounded-full bg-current pb-[25%] delay-400" />
      <div className="w-1/4 animate-elevator overflow-hidden rounded-full bg-current pb-[25%] delay-600" />
    </div>
  );
};
